import { getVimeoEmbedUrl, getYouTubeEmbedUrl } from '../../helpers/embed';

export const transformToEmbedUrl = (resource: string): string => {
    const youTubeEmbedUrl = getYouTubeEmbedUrl(resource);
    const vimeoEmbedUrl = getVimeoEmbedUrl(resource);

    return youTubeEmbedUrl || vimeoEmbedUrl || resource;
};
